import { render, staticRenderFns } from "./BitacoraDetails.vue?vue&type=template&id=f6ab2e8c&"
import script from "./BitacoraDetails.vue?vue&type=script&lang=js&"
export * from "./BitacoraDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports